import React, { useContext } from "react";
import { Button } from "react-bootstrap";
import { UseFormReturn } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { useHistory } from "react-router-dom";
import { MoneyApiForm } from "go-core/api/types";
import StickyFooter from "../../../components/StickyFooter";
import { OrderContext } from "../../../contexts/OrderContext";

interface Props {
	form: UseFormReturn<{ tip: MoneyApiForm }>;
}

const CustomTipStickyFooter = ({ form }: Props) => {
	const { t } = useTranslation();
	const { watch } = form;
	const history = useHistory();
	const { matchUrl } = useContext(OrderContext);

	const handleOnClick = () => {
		history.push(`${matchUrl}/payment?tipAmount=${watch("tip.amount")}`);
	};

	return (
		<StickyFooter>
			<Button
				onClick={handleOnClick}
				disabled={watch("tip.amount") === undefined || watch("tip.amount") === null}
			>
				{t("modules.e_order.action.go_to_payment.title")}
			</Button>
		</StickyFooter>
	);
};

export default CustomTipStickyFooter;
